export function getTheme() {
    if (window.matchMedia("(prefers-color-scheme: dark)").matches) return "dark";
    else {
        return "light";
    }
}
